// 科研工作经历
import { Form, Input } from '@roo/roo';
import React from 'react';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import { requiredRule } from '../../../../utils/rules';
import { FieldList } from '../../_components/FieldList';

const Field = Form.field;

const workInfoObj = {
  // workTime: [],
  startTime: '', // 开始时间
  endTime: '', // 结束时间
  companyName: '', // 公司名称
  post: '', // 职位
  workDesc: '', // 经历描述
};

const Research = (props) => (
  <FieldList {...props} name="workInfo" itemClassName="form-patch bc" iniData={workInfoObj} maxCount={10} minCount={1} plusText="添加科研工作经历">
    <Field
      required
      name="startTime"
      rule={{
        validator: (rule, value, callback) => {
          if (!value) {
            return callback('请选择日期');
          }
          return callback();
        },
      }}
      label="时&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;间"
    >
      {({
        disabled, item, setFieldValue, handleChange, idx,
      }) => {
        const { startTime, endTime: endtime } = item;
        const endTime = endtime === '至今' ? dayjs().format('YYYY-MM-DD') : endtime;
        return (
          <DatePicker.RangePicker
            className="as-roo-rangepicker"
            allowClear={false}
            disabled={disabled}
            disabledDate={(cur) => cur.unix() > Date.now() / 1000}
            value={startTime && endTime ? [dayjs(startTime), dayjs(endTime)] : undefined}
            onChange={(v) => {
              const [start, end] = v;
              handleChange(startTime);
              setFieldValue(`workInfo.${idx}`, {
                ...item,
                startTime:
                  dayjs(start).format('YYYY-MM-DD'),
                endTime: dayjs(end).format('YYYY-MM-DD'),
              });
            }}
            format={(value) => {
              if (dayjs().format('YYYY-MM-DD') === endTime && endTime === value.format('YYYY-MM-DD') && startTime !== value.format('YYYY-MM-DD')) {
                return '至今';
              }
              return value.format('YYYY-MM-DD');
            }}
            cellRender={(current, info) => {
              if (current.format('YYYY-MM-DD') === info.today.format('YYYY-MM-DD')) {
                return <div className="ant-picker-cell-inner">至今</div>;
              }
              return info.originNode;
            }}
          />
        );
      }}
    </Field>
    <Field
      required
      rule={requiredRule}
      label="单&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;位"
      name="companyName"
      as={
        <Input maxLength={100} placeholder="请输入您的科研工作单位" />
      }
    />
    <Field
      required
      rule={requiredRule}
      label="职&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;位"
      name="post"
      as={(
        <Input maxLength={50} placeholder="请输入您的职位名称" />
      )}
    />
    <Field hid label="合作导师" name="mentor" as={<Input maxLength={50} placeholder="请输入您的合作导师" />} />
    <br />
  </FieldList>
);

export default Research;
